import { render, staticRenderFns } from "./BaseCalendarIconItem.vue?vue&type=template&id=74ea28cc&scoped=true"
import script from "./BaseCalendarIconItem.vue?vue&type=script&lang=js"
export * from "./BaseCalendarIconItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea28cc",
  null
  
)

export default component.exports